exports.en = {
  MARKER_CONTENT: {
    OPEN: 'Opening hours',
    CLOSED: 'Closed today'
  }
}
